import React, { Suspense, lazy } from "react";
import { Switch, Redirect, Route, useHistory } from "react-router-dom";
import NotFound from "../components/helpersUI/NotFound.jsx";
import PreLoader from "../components/helpersUI/loading/PreLoader";

const Agendamiento = lazy(() =>
  import("../components/company/schedule/Agendamiento.jsx")
);
const AgendamientoMobile = lazy(() =>
  import("../components/company/schedule/mobile/AgendamientoMobile.jsx")
);
const AgendamientoSalcobrand = lazy(() =>
  import("../components/company/schedule/salcobrand/AgendamientoSalcobrand.jsx")
);
const Terms = lazy(() => import("../components/company/Terms.jsx"));
const TermsMobile = lazy(() => import("../components/company/TermsMobile.jsx"));
const Rights = lazy(() => import("../components/company/Rights"));
const Politics = lazy(() => import("../components/company/Politics"));
const FAQ = lazy(() => import("../components/company/FAQ"));

const PrivacyPolicyEcuador = lazy(() =>
  import("../components/company/PrivacyPolicyEcuador.jsx")
);
const SuggestionBox = lazy(() =>
  import("../components/company/home/SuggestionBox.jsx")
);
const AccessPatient = lazy(() =>
  import("../components/company/patient/AccessPatient.jsx")
);
const AccessGuest = lazy(() =>
  import("../components/company/guest/AccessGuest.jsx")
);
const AccessPatientInformed = lazy(() =>
  import("../components/company/patient/AccessPatientInformed.jsx")
);
const InformedConsent = lazy(() =>
  import("../components/company/InformedConsent.jsx")
);
const RegisterScreenDataPatient = lazy(() =>
  import(
    "../components/company/doctor/colombia/registerpatient/RegisterScreenDataPatient.jsx"
  )
);
const PayScreen = lazy(() =>
  import("../components/company/schedule/PayScreen.jsx")
);
const NotifySchedule = lazy(() =>
  import("../components/company/schedule/NotifySchedule.jsx")
);

const PageNotFound = lazy(() => import("./PageNotFound.jsx"));
const RecordChile = lazy(() =>
  import("../components/company/doctor/chile/RecordEcuador.jsx")
);

/*
 Faltan las rutas para los siguientes componentes:
 [ ] DeleteUsers
 [ ] SurveyTIC
*/

function RoutesPublic({ companyName, permissionsRoutes, statusRoutes }) {
  const history = useHistory(); // Obtener el objeto history

  function createCustomRoute(path, component, condition) {
    return (
      <Route
        exact
        path={path}
        render={(props) => {
          if (condition) {
            return (
              <Suspense
                fallback={
                  <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-saluta-s to-saluta-c">
                    <PreLoader
                      text={"Cargando"}
                      classText="text-white font-bold z-100"
                      opacity={50}
                      isLoading={true}
                    />
                  </div>
                }
              >
                {component}
              </Suspense>
            );
          } else {
            return (
              <div className="flex items-center justify-center min-h-screen text-center bg-gradient-to-r from-saluta-s to-saluta-c">
                <NotFound msg="Recurso no autorizado" />
              </div>
            );
          }
        }}
      />
    );
  }

  const arrayRoutes = [
    `/${companyName}/Agendamiento`,
    `/${companyName}/Agendamiento/mobile`,
    `/${companyName}/Terms`,
    `/${companyName}/Rights`,
    `/${companyName}/Politics`,
    `/${companyName}/FAQ`,
    `/${companyName}/PrivacyPolicyEc`,
    `/${companyName}/quejas`,
    `/${companyName}/Acceso_Atencion/:country/:document`,
    `/${companyName}/Acceso_Consentimiento/:country/:document`,
    `/${companyName}/InformedConsent`,
    `/${companyName}/registro-de-paciente/:id`,
    `/${companyName}/payment/:country/:id`,
    `/${companyName}/Notify/:country/:orderClient`,
    `/${companyName}/Ecuador/:id`,
    `/${companyName}`,
    `/${companyName}/auth/login`,
  ];

  const AgendamientoRoute = createCustomRoute(
    "/:company/Agendamiento",
    <Agendamiento />,
    permissionsRoutes?.permissionSchedule
  );
  const AgendamientoMobileRoute = createCustomRoute(
    "/:company/Agendamiento/mobile",
    <AgendamientoMobile company={companyName} />,
    permissionsRoutes?.permissionScheduleMobile
  );
  const AgendamientoSalcobrandRoute = createCustomRoute(
    "/:company/Agendamiento/mobile/Salcobrand",
    <AgendamientoSalcobrand company={companyName} />,
    permissionsRoutes?.permissionScheduleSalcobrand
  );
  const TermsRoute = createCustomRoute(
    "/:company/Terms",
    <Terms />,
    permissionsRoutes?.permissionTerms
  );
  const TermsMobileRoute = createCustomRoute(
    "/:company/TermsMobile",
    <TermsMobile />,
    permissionsRoutes?.permissionTermsMobile
  );
  const RightsRoute = createCustomRoute(
    "/:company/Rights",
    <Rights />,
    permissionsRoutes?.permissionRights
  );
  const PoliticsRoute = createCustomRoute(
    "/:company/Politics",
    <Politics />,
    permissionsRoutes?.permissionPolitics
  );
  const FaqRoute = createCustomRoute(
    "/:company/FAQ",
    <FAQ />,
    permissionsRoutes?.permissionFaq
  );
  const PrivPolicyEcRoute = createCustomRoute(
    "/:company/PrivacyPolicyEc",
    <PrivacyPolicyEcuador />,
    permissionsRoutes?.permissionPolicyEcuador
  );
  const SuggestionsRoute = createCustomRoute(
    "/:company/quejas",
    <SuggestionBox />,
    permissionsRoutes?.permissionSuggestionBox
  );
  const AccessPatientRoute = createCustomRoute(
    "/:company/Acceso_Atencion/:country/:document",
    <AccessPatient />,
    permissionsRoutes?.permissionAccessPatient
  );
  const AccessInformedRoute = createCustomRoute(
    "/:company/Acceso_Consentimiento/:country/:document",
    <AccessPatientInformed />,
    permissionsRoutes?.permissionPatientInformed
  );
  const AccessGuestRoute = createCustomRoute(
    "/:company/Acceso_Invitado/:country/:document",
    <AccessGuest />,
    permissionsRoutes?.permissionAccessGuest
  );
  const InformedRoute = createCustomRoute(
    "/:company/InformedConsent",
    <InformedConsent />,
    permissionsRoutes?.permissionInformedConsent
  );
  const RegisterPatientIdRoute = createCustomRoute(
    "/:company/registro-de-paciente/:id",
    <RegisterScreenDataPatient />,
    permissionsRoutes?.permissionRegisterPatientId
  );
  const PayScreenRoute = createCustomRoute(
    "/:company/payment/:country/:id",
    <PayScreen />,
    permissionsRoutes?.permissionPaymentSchedule
  );
  const NotifyRoute = createCustomRoute(
    "/:company/Notify/:country/:orderClient",
    <NotifySchedule />,
    permissionsRoutes?.permissionNotifyPayment
  );
  const AttentionEcRoute = createCustomRoute(
    "/:company/Ecuador/:id",
    <RecordChile />,
    permissionsRoutes?.permissionAttentionEC
  );

  return (
    <>
      <Switch>
        {AgendamientoRoute}
        {AgendamientoMobileRoute}
        {AgendamientoSalcobrandRoute}
        {TermsRoute}
        {TermsMobileRoute}
        {RightsRoute}
        {PoliticsRoute}
        {FaqRoute}
        {PrivPolicyEcRoute}
        {SuggestionsRoute}
        {AccessPatientRoute}
        {AccessInformedRoute}
        {AccessGuestRoute}
        {InformedRoute}
        {RegisterPatientIdRoute}
        {PayScreenRoute}
        {NotifyRoute}
        {AttentionEcRoute}

        <Route
          path={`/${companyName}`}
          render={({ location }) => {
            // Verificar si la ruta actual está en el array de rutas permitidas
            const isRouteAllowed = arrayRoutes.includes(location.pathname);

            // Si el usuario no está autenticado o la ruta no está permitida, redirigir a la página de autenticación o a la 404
            if (!statusRoutes.isLoggedIn && isRouteAllowed) {
              return <Redirect to={`/${companyName}/auth/login`} />;
            }
            // : (
            // <Redirect to="/404" />

            history.push(`/${companyName}`);
            // );
          }}
        />
      </Switch>
      <Route
        path="/404"
        render={() => {
          return (
            <Suspense
              fallback={
                <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-saluta-s to-saluta-c">
                  <PreLoader
                    text={"Cargando"}
                    classText="text-white font-bold z-100"
                    opacity={50}
                    isLoading={true}
                  />
                </div>
              }
            >
              <PageNotFound />
            </Suspense>
          );
        }}
      />
    </>
  );
}

export default RoutesPublic;
